export const OutOfStateBannerWrapper = {
  marginBottom: '$md',
  '@media (max-width: 1268px)': {
    width: '20%',
  },
  '@media (max-width: 984px)': {
    width: '94%',
  },
};
